<template>
    <div>
        <input
            class="input"
            :class="{ 'is-danger' : errors.has(formName) }"
            :name="formName"
            v-model="localValue.value"
            v-validate="'required'"
            @keypress.enter="$emit('enter')"
        />
        <div
            class="error-message"
            v-show="errors.has(formName)"
        >
            You must enter a value
        </div>
    </div>
</template>

<script>
export default {
    inject : ['$validator'],
    props : {
        value : {
        },
        formName : {
            type : String,
            required : true,
        },
    },
    computed : {
        localValue : {
            get () { return this.value },
            set () { this.$emit('input', this.localValue )}
        }
    },
}
</script>

<style scoped>

</style>
